export default __webpack_public_path__ + "../img/92d073d64f5a443ecd66f10c4c604d43.png";